import { signalStore } from '@ngrx/signals';
import { AbstractQueryParams, withActions, withSelectors } from '@res/ngg-core';
import { CompanyData, CompanyId, CompanyModel } from '../../schema/schema.interface';
import { CompanyActions } from './company.action';
import { CompanyState } from './company.state';

export interface CompanyStateModel {
  companies: { data: CompanyData; id: CompanyId }[] | [];
  isLoading: boolean;
  filter?: { query: AbstractQueryParams<CompanyModel>[] };
}

export const CompanyStore = signalStore(
  // Selectors
  { protectedState: false },
  withSelectors({
    companies: CompanyState.companies,
    companyState: CompanyState.companyState,
  }),
  // Actions
  withActions({
    getAllCompany: CompanyActions.GetAllCompany,
    queryCompany: CompanyActions.QueryCompany,
  }),
);
